import { render } from "./ErrorNotification.vue?vue&type=template&id=154d5e89"
import script from "./ErrorNotification.vue?vue&type=script&lang=js"
export * from "./ErrorNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__